// extracted by mini-css-extract-plugin
export default {"gantt-task-label":"ProjectGantt_gantt-task-label__bCYpj","code":"ProjectGantt_code__oDh5Q","text":"ProjectGantt_text__CxBFI","overflow-scroll":"ProjectGantt_overflow-scroll__xKoX8"};